import { render } from "./DriversChanges.vue?vue&type=template&id=0c98906c&scoped=true"
import script from "./DriversChanges.vue?vue&type=script&lang=js"
export * from "./DriversChanges.vue?vue&type=script&lang=js"

import "./DriversChanges.vue?vue&type=style&index=0&id=0c98906c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c98906c"]])

export default __exports__